import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useQuotationPopupState } from "../../../hooks/use-app-state";
import { QuotationPopupValidateDocumentNumber } from "../../../redux/quotation-popup/actions/default";
import { TextField } from "../../shared/form-fields/text-field";
import { quotationPopupFormDefinition } from "../constants/form-fields-definition";
import { useQuotationPopupFormContext } from "../hooks/use-quotation-popup-form";

export const QuotationPopupDocumentNumberField: React.FC = () => {
    const rhForm = useQuotationPopupFormContext();
    const dispatch = useDispatch();
    const validatingDocumentNumber = useQuotationPopupState<boolean>([
        "form",
        "validatingDocumentNumber",
    ]);
    const documentNumberValue = rhForm.watch(
        quotationPopupFormDefinition.documentNumber.key
    );
    const documentNumberHasErrors = rhForm.errors.documentNumber;
    const handleBlur = useCallback(() => {
        if (!!documentNumberValue && !documentNumberHasErrors) {
            dispatch(new QuotationPopupValidateDocumentNumber(rhForm).create());
        }
    }, [documentNumberHasErrors, documentNumberValue]);
    return (
        <div>
            <TextField
                data-testid="QuotationPopupDocumentNumberField"
                inputRef={rhForm.register}
                fieldDefinition={quotationPopupFormDefinition.documentNumber}
                rhForm={rhForm}
                loading={validatingDocumentNumber}
                onBlur={handleBlur}
            />
        </div>
    );
};
